<template>
  <div class="content">
    <!-- 已审核/未审核切换 -->
    <div class="btnSwitch">
      <el-button
        @click="unaudited('1')"
        class="testTypeBtn"
        :class="{ isActiveClass: testType === '1' }"
        >未审核考生</el-button
      >
      <el-button
        @click="unaudited('0')"
        class="testTypeBtn"
        :class="{ isActiveClass: testType === '0' }"
        >已审核考生</el-button
      >
    </div>
    <div class="detailContent">
      <div class="flex_box">
        <div class="serchTerms">
          <!-- 搜索条件 -->
          <div class="input_box">
            <span>考生姓名：</span>
            <el-input
              v-model.trim="auditStatus"
              placeholder="请输入考生姓名"
              style="width: 200px"
            ></el-input>
          </div>

          <div class="input_account" v-if="status">
            <span class="labelTitle">考试账号：</span>
            <el-input
              v-model.trim="input_account"
              placeholder="请输入考试账号"
              style="width: 200px"
            ></el-input>
          </div>

          <div class="select_box">
            <span>科室：</span>
            <el-select
              v-model="departmentName"
              placeholder="全部"
              class="hosname"
              @change="handleQuery($event, 'isState')"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in options_ks"
                :key="item.DepartmentID"
                :label="item.DepartmentName"
                :value="item.DepartmentName"
                style="width: 200px"
              >
              </el-option>
            </el-select>
          </div>

          <div class="select_box">
            <span>职称：</span>
            <el-select
              v-model="pTitle"
              placeholder="全部"
              class="hosname"
              @change="handleQuery($event, 'isState')"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in options_zc"
                :key="item.pTitleID"
                :label="item.PTitle"
                :value="item.PTitle"
                style="width: 200px"
              >
              </el-option>
            </el-select>
          </div>

          <div v-if="status1">
            <span>审核状态：</span>
            <el-select
              v-model="AuditValue"
              placeholder="全部"
              class="hosname"
              @change="handleQuery($event, 'isState')"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="审核驳回" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="query_btn">
          <el-button
            @click="handleQuery()"
            type="primary"
            icon="el-icon-search"
            class="searchbtn"
            >搜索</el-button
          >
          <el-button
            @click="resetQuery()"
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            >重置</el-button
          >
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="operaBtn" v-if="status">
        <el-button :disabled="multiple" @click="addExaminee()" plain>
          <i class="iconfont icon-action-add-hover"></i>批量审核通过
        </el-button>
        <el-button :disabled="multiple" @click="bulkImportBtn()" plain>
          <i class="iconfont icon-jiami"></i>批量审核驳回
        </el-button>
      </div>

      <!-- 表格内容 -->
      <div class="AuditTable" v-if="status">
        <el-table
          ref="table"
          :data="getAuditData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          @row-click="StepsListRowClick"
          v-loading="loading"
        >
          <el-table-column
            type="selection"
            width="60"
            align="center"
          ></el-table-column>

          <el-table-column label="序号" type="index" width="60" align="center"
            ><template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template></el-table-column
          >

          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="index == 0">{{ scope.row.UserName }}</p>
              <p v-if="index == 1">{{ scope.row.RealName }}</p>
              <p v-if="index == 2">{{ scope.row.DepartmentName }}</p>
              <p v-if="index == 3">{{ scope.row.PTitle }}</p>
              <p v-if="index == 4">{{ scope.row.Position }}</p>
              <p v-if="index == 5">
                {{
                  scope.row.Birthday == null
                    ? null
                    : $moment(scope.row.Birthday).format("YYYY-MM-DD")
                }}
              </p>
              <p v-if="index == 6">{{ scope.row.JobDate }}</p>
              <p v-if="index == 7">
                {{
                  scope.row.CreateTime == null
                    ? null
                    : $moment(scope.row.CreateTime).format("YYYY/MM/DD HH:mm")
                }}
              </p>
            </template>
          </el-table-column>

          <el-table-column
            prop="address"
            label="操作"
            align="center"
            width="220"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  @click.stop="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click.stop="passAduit(scope.row)"
                  >审核通过</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click.stop="reviewRejected(scope.row)"
                  >审核驳回</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 表格内容2 -->
      <div class="AuditTable" v-if="status1">
        <el-table
          ref="table1"
          :data="getReviewData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange1"
        >
          <el-table-column
            type="selection"
            width="60"
            align="center"
          ></el-table-column>

          <el-table-column label="序号" type="index" width="60" align="center"
            ><template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template></el-table-column
          >

          <el-table-column
            v-for="(item, index) in formColumns1"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="index == 0">{{ scope.row.UserName }}</p>
              <p v-if="index == 1">{{ scope.row.RealName }}</p>
              <p v-if="index == 2">{{ scope.row.DepartmentName }}</p>
              <p v-if="index == 3">{{ scope.row.PTitle }}</p>
              <p v-if="index == 4">{{ scope.row.Position }}</p>
              <p v-if="index == 5">
                {{
                  scope.row.UpdateTime == null
                    ? null
                    : $moment(scope.row.UpdateTime).format("YYYY-MM-DD")
                }}
              </p>
              <p v-if="index == 6">{{ scope.row.JobDate }}</p>
              <p v-if="index == 7">
                <span v-if="scope.row.ExamineType === 1" style="color: #00d299"
                  >审核通过</span
                >
                <span
                  v-else-if="scope.row.ExamineType === 0"
                  style="color: #ff3131"
                  >审核驳回</span
                >
                <span v-else>{{ scope.row.ExamineType }}</span>
              </p>
              <p v-if="index == 8">{{ scope.row.ExamineRemark }}</p>
              <p v-if="index == 9">
                {{
                  scope.row.CreateTime == null
                    ? null
                    : $moment(scope.row.CreateTime).format("YYYY/MM/DD HH:mm")
                }}
              </p>
              <p v-if="index == 10">
                {{
                  scope.row.ExamineTime == null
                    ? null
                    : $moment(scope.row.ExamineTime).format("YYYY/MM/DD HH:mm")
                }}
              </p>
              <p v-if="index == 11">{{ scope.row.ExamineUserName }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="footBox">
        <div class="footPage">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handlePrevClick"
            @next-click="handleNextClick"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pagesizesArr"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 考生新增/编辑弹框 -->
    <div class="newAddKS">
      <el-dialog
        :title="isEdit ? '编辑考生' : '添加考生'"
        :visible.sync="dialogFormVisible"
      >
        <create-or-edit
          :key="timer"
          :is-edit="isEdit"
          @success="handleSucces()"
          @cancel="dialogFormVisible = false"
        >
        </create-or-edit>
      </el-dialog>
    </div>

    <!-- 弹框 -->
    <div class="deleteBatches">
      <el-dialog :title="typeTitle" :visible.sync="dialogDelVisible">
        <span class="dialogContent">{{ content }}</span>
        <textarea
          v-model="textareaContent"
          name=""
          id="area"
          cols="30"
          rows="10"
          autofocus
        ></textarea>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogDelVisible = false">取 消</el-button>
          <el-button type="primary" @click="switchElement(flag)"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";

import CreateOrEdit from "./components/editListData.vue";
import {
  getSectionList,
  getPTitleList,
  examineStudentList,
  examineReadyStudentList,
  examineStudent,
} from "@/services/examManager.js";

export default {
  name: "reviewList",
  components: {
    CreateOrEdit,
  },
  data() {
    return {
      flag: -1,
      rowData: "",
      textareaContent: "",

      auditStatus: "",
      input_account: "",
      departmentName: "",
      pTitle: "",
      AuditValue: "",

      reviewListPara: new Object(),
      readyListPara: new Object(),
      loading: true,
      // 编辑状态
      isEdit: false,
      // 科室
      options_ks: [],
      // 职称
      options_zc: [],
      // 已审核
      getReviewData: [],
      // 未审核
      getAuditData: [],
      currentPage: 1, //  当前页数
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 100,
      // 未审核数组
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      multipleSelection: [], // 当前页选中的数据
      changePageCoreRecordDataStats: true,
      idKey: "UserID",
      formColumns: [
        {
          prop: "UserName",
          label: "考生账号",
        },
        {
          prop: "RealName",
          label: "考生姓名",
        },
        {
          prop: "DepartmentName",
          label: "科室",
        },
        {
          prop: "PTitle",
          label: "职称",
        },
        {
          prop: "Position",
          label: "职位",
        },
        {
          prop: "Birthday",
          label: "出生年月",
        },
        {
          prop: "JobDate",
          label: "工作年限",
        },
        {
          prop: "CreateTime",
          label: "提交时间",
        },
      ],
      // 已审核数组
      multipleSelectionAll1: [], // 所有选中的数据包含跨页数据
      multipleSelection1: [], // 当前页选中的数据
      changePageCoreRecordDataStats1: true,
      formColumns1: [
        {
          prop: "UserName",
          label: "考生账号",
        },
        {
          prop: "RealName",
          label: "考生姓名",
        },
        {
          prop: "DepartmentName",
          label: "科室",
        },
        {
          prop: "PTitle",
          label: "职称",
        },
        {
          prop: "Position",
          label: "职位",
        },
        {
          prop: "UpdateTime1",
          label: "出生年月",
        },
        {
          prop: "JobDate",
          label: "工作年限",
        },
        {
          prop: "ExamineType1",
          label: "审核状态",
        },
        {
          prop: "ExamineRemark1",
          label: "备注",
        },
        {
          prop: "CreateTime1",
          label: "提交时间",
          width: "140px",
        },
        {
          prop: "ExamineTime1",
          label: "审核时间",
          width: "140px",
        },
        {
          prop: "ExamineUserName",
          label: "操作账号",
        },
      ],
      // 弹框状态
      dialogFormVisible: false,
      // 审核驳回状态
      dialogDelVisible: false,
      typeTitle: "",
      content: "",
      isLoading: false,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      testType: "1",
      status: true,
      status1: false,
      timer: "",
      editData: [],
    };
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // handlePageData() {
    //   this.getAuditData = this.getAuditData.map((item) => {
    //     item.UpdateTime1 = this.$moment(item.UpdateTime).format("YYYY-MM-DD");
    //     item.CreateTime1 = this.$moment(item.CreateTime).format(
    //       "YYYY-MM-DD hh:mm"
    //     );
    //     item.ExamineTime1 = this.$moment(item.ExamineTime).format(
    //       "YYYY-MM-DD hh:mm"
    //     );
    //     return item;
    //   });
    // },
    // handlePageDataOfReview() {
    //   this.getReviewData = this.getReviewData.map((item) => {
    //     item.UpdateTime1 = this.$moment(item.UpdateTime).format("YYYY-MM-DD");
    //     item.CreateTime1 = this.$moment(item.CreateTime).format(
    //       "YYYY-MM-DD hh:mm"
    //     );
    //     item.ExamineTime1 = this.$moment(item.ExamineTime).format(
    //       "YYYY-MM-DD hh:mm"
    //     );
    //     if (item.ExamineType === 1) {
    //       item.ExamineType1 = "审核通过";
    //     } else if (item.ExamineType === 0) {
    //       item.ExamineType1 = "审核驳回";
    //     }
    //     if (item.ExamineRemark == null) {
    //       item.ExamineRemark1 = "无";
    //     }
    //     return item;
    //   });
    // },

    handleSucces() {
      this.dialogFormVisible = false;
      this.UnAnditExamListData();
    },

    // 设置选中的方法
    setSelectRow() {
      if (this.status) {
        if (
          !this.multipleSelectionAll ||
          this.multipleSelectionAll.length <= 0
        ) {
          return;
        }
        // 标识当前行的唯一键的名称
        let idKey = this.idKey;
        let selectAllIds = [];
        this.multipleSelectionAll.forEach((row) => {
          selectAllIds.push(row[idKey]);
        });
        this.$refs.table.clearSelection();
        for (var i = 0; i < this.getAuditData.length; i++) {
          if (selectAllIds.indexOf(this.getAuditData[i][idKey]) >= 0) {
            // 设置选中，记住table组件需要使用ref="table"
            this.$refs.table.toggleRowSelection(this.getAuditData[i], true);
          }
        }
      }

      if (this.status1) {
        if (
          !this.multipleSelectionAll1 ||
          this.multipleSelectionAll1.length <= 0
        ) {
          return;
        }
        // 标识当前行的唯一键的名称
        let idKey = this.idKey;
        let selectAllIds = [];
        this.multipleSelectionAll1.forEach((row) => {
          selectAllIds.push(row[idKey]);
        });
        this.$refs.table1.clearSelection();
        for (var i = 0; i < this.getReviewData.length; i++) {
          if (selectAllIds.indexOf(this.getReviewData[i][idKey]) >= 0) {
            // 设置选中，记住table组件需要使用ref="table"
            this.$refs.table1.toggleRowSelection(this.getReviewData[i], true);
          }
        }
      }
    },

    // 记忆选择核心方法
    changePageCoreRecordData() {
      if (this.status) {
        // 标识当前行的唯一键的名称
        let idKey = this.idKey;
        let that = this;
        // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
        if (this.multipleSelectionAll.length <= 0) {
          this.multipleSelectionAll = this.multipleSelection;
          return;
        }
        // 总选择里面的key集合
        let selectAllIds = [];
        this.multipleSelectionAll.forEach((row) => {
          selectAllIds.push(row[idKey]);
        });
        let selectIds = [];
        // 获取当前页选中的id
        this.multipleSelection.forEach((row) => {
          selectIds.push(row[idKey]);
          // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
          if (selectAllIds.indexOf(row[idKey]) < 0) {
            that.multipleSelectionAll.push(row);
          }
        });
        let noSelectIds = [];
        // 得到当前页没有选中的id
        this.getAuditData.forEach((row) => {
          if (selectIds.indexOf(row[idKey]) < 0) {
            noSelectIds.push(row[idKey]);
          }
        });
        noSelectIds.forEach((id) => {
          if (selectAllIds.indexOf(id) >= 0) {
            for (let i = 0; i < that.multipleSelectionAll.length; i++) {
              if (that.multipleSelectionAll[i][idKey] == id) {
                // 如果总选择中有未被选中的，那么就删除这条
                that.multipleSelectionAll.splice(i, 1);
                break;
              }
            }
          }
        });
        //console.log(this.multipleSelectionAll, "multipleSelectionAll");
        //console.log(this.multipleSelection, "multipleSelection");
      }

      if (this.status1) {
        // 标识当前行的唯一键的名称
        let idKey = this.idKey;
        let that = this;
        // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
        if (this.multipleSelectionAll1.length <= 0) {
          this.multipleSelectionAll1 = this.multipleSelection1;
          return;
        }
        // 总选择里面的key集合
        let selectAllIds = [];
        this.multipleSelectionAll1.forEach((row) => {
          selectAllIds.push(row[idKey]);
        });
        let selectIds = [];
        // 获取当前页选中的id
        this.multipleSelection1.forEach((row) => {
          selectIds.push(row[idKey]);
          // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
          if (selectAllIds.indexOf(row[idKey]) < 0) {
            that.multipleSelectionAll1.push(row);
          }
        });
        let noSelectIds = [];
        // 得到当前页没有选中的id
        this.getReviewData.forEach((row) => {
          if (selectIds.indexOf(row[idKey]) < 0) {
            noSelectIds.push(row[idKey]);
          }
        });
        noSelectIds.forEach((id) => {
          if (selectAllIds.indexOf(id) >= 0) {
            for (let i = 0; i < that.multipleSelectionAll1.length; i++) {
              if (that.multipleSelectionAll1[i][idKey] == id) {
                // 如果总选择中有未被选中的，那么就删除这条
                that.multipleSelectionAll1.splice(i, 1);
                break;
              }
            }
          }
        });
        //console.log(this.multipleSelectionAll1, "multipleSelectionAll1");
        //console.log(this.multipleSelection1, "multipleSelection1");
      }
    },

    // 得到选中的所有数据
    getAllSelectionData() {
      // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
      this.changePageCoreRecordData();
      // console.log(this.multipleSelectionAll);
      if (this.status) {
        return this.multipleSelectionAll;
      }

      if (this.status1) {
        return this.multipleSelectionAll1;
      }
    },

    // 得到选中的所有数据的id
    getAllSelectionUserID() {
      let data = this.getAllSelectionData();
      let UserIDs = [];
      data.forEach((element) => {
        UserIDs.push(element.UserID);
      });
      return UserIDs;
    },

    // 显示条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.changePageCoreRecordData();
      this.pageSize = val;
      this.loading = true;
      if (this.status) {
        this.UnAnditExamListData();
      }
      if (this.status1) {
        this.examineReadyStudentList();
      }
      console.log(`每页 ${val} 条`);
    },

    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.changePageCoreRecordData();
      this.currentPage = val;
      this.loading = true;
      if (this.status) {
        this.changePageCoreRecordDataStats = false;
        // this.handlePageData();
        this.UnAnditExamListData();
      }
      if (this.status1) {
        this.changePageCoreRecordDataStats1 = false;
        // this.handlePageDataOfReview();
        this.examineReadyStudentList();
      }
    },

    // 上一页
    handlePrevClick() {
      if (this.status) {
        this.UnAnditExamListData();
      }
      if (this.status1) {
        this.examineReadyStudentList();
      }
    },
    // 下一页
    handleNextClick() {
      if (this.status) {
        this.UnAnditExamListData();
      }
      if (this.status1) {
        this.examineReadyStudentList();
      }
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log("多选框选中数据...");
      if (this.status) {
        this.multipleSelection = selection;
        if (this.changePageCoreRecordDataStats) {
          this.changePageCoreRecordData();
        }
        this.multiple = !this.multipleSelectionAll.length;

        let arr = [];
        this.multipleSelectionAll.forEach((element) => {
          arr.push(element.RealName);
        });
        console.log(arr, "<<======multipleSelectionAll");
      }

      // this.ids = selection.map((item) => item.groupID);
      // this.multiple = !selection.length;
      // this.single = selection.length != 1;
      // console.log(this.ids);
    },

    handleSelectionChange1(selection) {
      console.log("多选框选中数据...");
      if (this.status1) {
        this.multipleSelection1 = selection;
        if (this.changePageCoreRecordDataStats1) {
          this.changePageCoreRecordData();
        }
        this.multiple = !this.multipleSelectionAll1.length;

        let arr = [];
        this.multipleSelectionAll1.forEach((element) => {
          arr.push(element.RealName);
        });
        console.log(arr, "<<======multipleSelectionAll1");
      }
    },

    // 未审核
    unaudited(type) {
      if (this.testType !== type) {
        if (this.testType === "1") {
          this.testType = "0";
          this.status = false;
          this.status1 = true;
          // 初始化条件筛选框
          this.auditStatus = "";
          this.input_account = "";
          this.departmentName = "";
          this.pTitle = "";
          // 初始化多选框
          this.multipleSelectionAll = [];
          this.multipleSelection = [];
          this.changePageCoreRecordDataStats = true;
          // 初始化查询接口请求参数
          this.currentPage = 1;
          this.reviewListPara.realName = "";
          this.reviewListPara.userName = "";
          this.reviewListPara.department = "";
          this.reviewListPara.pTitle = "";
          this.examineReadyStudentList();
        } else {
          this.testType = "1";
          this.status = true;
          this.status1 = false;
          // 初始化条件筛选框
          this.auditStatus = "";
          this.departmentName = "";
          this.pTitle = "";
          this.AuditValue = "";
          // 初始化多选框
          this.multipleSelectionAll1 = [];
          this.multipleSelection1 = [];
          this.changePageCoreRecordDataStats1 = true;
          // 初始化查询接口请求参数
          this.currentPage = 1;
          this.readyListPara.searchStr = "";
          this.readyListPara.department = "";
          this.readyListPara.pTitle = "";
          this.readyListPara.examineType = "";
          this.UnAnditExamListData();
        }
      }
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 未审核考生列表数据
    async UnAnditExamListData() {
      // console.log(realName);
      // console.log(userName);
      // console.log(department);
      // console.log(pTitle);
      const reviewListPara = this.reviewListPara;
      this.UtilFun(reviewListPara);
      reviewListPara.pageIndex = this.currentPage - 1;
      reviewListPara.eachPageNum = this.pageSize;
      console.log(reviewListPara, "待审核考生列表请求数据");
      this.isLoading = true;
      const { data } = await examineStudentList(reviewListPara);
      if (data.Status === 200) {
        this.isLoading = false;
        console.log(data, "待审核考生列表返回数据");
        this.getAuditData = data.Data.data;
        this.total = data.Data.count;
        // this.handlePageData();
        setTimeout(() => {
          this.changePageCoreRecordDataStats = true;
          this.loading = false;
          this.setSelectRow();
        }, 200);
      } else {
        this.$message.error(data.Data);
      }
    },

    // 已审核考生列表数据
    async examineReadyStudentList() {
      const readyListPara = this.readyListPara;
      this.UtilFun(readyListPara);
      readyListPara.pageIndex = this.currentPage - 1;
      readyListPara.eachPageNum = this.pageSize;
      console.log(readyListPara, "《《已审核考生列表请求数据");
      const { data } = await examineReadyStudentList(readyListPara);
      console.log(data, "《《已审核考生列表返回数据");
      if (data.Status === 200) {
        this.getReviewData = data.Data.data;
        this.total = data.Data.count;
        // this.handlePageDataOfReview();
        setTimeout(() => {
          this.changePageCoreRecordDataStats1 = true;
          this.loading = false;
          this.setSelectRow();
        }, 200);
      } else {
        this.$message.error(data.Data);
      }
    },

    // 批量审核通过或不通过
    async examineStudent(reqParam) {
      const { data } = await examineStudent(reqParam);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("操作成功");
        // 刷新列表
        this.UnAnditExamListData();
      } else {
        this.$message.error("操作失败");
      }
    },

    // 科室下拉框数据
    async getSectionData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data.Data, "科室下拉列表数据");
        this.options_ks = data.Data;
      }
    },
    // 职称下拉框数据
    async getPTitleData() {
      const sectionObj = new Object();
      sectionObj.userID = parseInt(this.$store.state.userID);
      sectionObj.guid = this.$store.state.user;
      sectionObj.hid = parseInt(this.$store.state.hid);
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        this.options_zc = data.Data;
        this.options_zc = this.options_zc.forEach((element, index) => {
          element.pTitleID = index;
        });
        this.options_zc = data.Data;
      }
    },

    // 搜索
    handleQuery(item, res) {
      // 未审核
      if (res == "isState") {
        this.readyListPara.department = "";
        this.readyListPara.pTitle = "";
        this.reviewListPara.department = "";
        this.reviewListPara.pTitle = "";
        this.readyListPara.searchStr = "";
      }

      if (this.status) {
        // 初始化多选框
        this.multipleSelectionAll = [];
        this.multipleSelection = [];
        this.changePageCoreRecordDataStats = true;
        // 初始化查询接口请求参数
        this.currentPage = 1;
        if (this.auditStatus) {
          this.reviewListPara.realName = this.auditStatus;
        } else {
          this.reviewListPara.realName = "";
        }
        if (this.input_account) {
          this.reviewListPara.userName = this.input_account;
        } else {
          this.reviewListPara.userName = "";
        }
        if (this.departmentName) {
          this.reviewListPara.department = this.departmentName;
        } else {
          this.reviewListPara.department = "";
        }
        if (this.pTitle) {
          this.reviewListPara.pTitle = this.pTitle;
        } else {
          this.reviewListPara.pTitle = "";
        }
        this.Buriedpoint(
          {
            code: "Examinee:ListOfGroups:tab1:search",
            parent_code: "Examinee:ReviewList",
          },
          "statetime"
        );
        this.UnAnditExamListData();
      }
      // 已审核
      if (this.status1) {
        // 初始化多选框
        this.multipleSelectionAll1 = [];
        this.multipleSelection1 = [];
        this.changePageCoreRecordDataStats1 = true;
        // 初始化查询接口请求参数
        this.currentPage = 1;
        // 考生姓名
        if (this.auditStatus) {
          this.readyListPara.searchStr = this.auditStatus;
        } else {
          this.readyListPara.searchStr = "";
        }
        if (this.departmentName) {
          this.readyListPara.department = this.departmentName;
        } else {
          this.readyListPara.department = "";
        }
        if (this.pTitle) {
          this.readyListPara.pTitle = this.pTitle;
        } else {
          this.readyListPara.pTitle = "";
        }
        if (this.AuditValue) {
          this.readyListPara.examineType = this.AuditValue;
        } else {
          this.readyListPara.examineType = "";
        }
        this.Buriedpoint(
          {
            code: "Examinee:ListOfGroups:tab2:search",
            parent_code: "Examinee:ReviewList",
          },
          "statetime"
        );
        this.examineReadyStudentList();
      }
    },
    // 重置
    resetQuery() {
      this.loading = true;
      // 未审核
      if (this.status) {
        // 初始化条件筛选框
        this.auditStatus = "";
        this.input_account = "";
        this.departmentName = "";
        this.pTitle = "";
        // 初始化多选框
        this.multipleSelectionAll = [];
        this.multipleSelection = [];
        this.changePageCoreRecordDataStats = true;
        // 初始化查询接口请求参数
        this.currentPage = 1;
        this.reviewListPara.realName = "";
        this.reviewListPara.userName = "";
        this.reviewListPara.department = "";
        this.reviewListPara.pTitle = "";
        this.Buriedpoint(
          {
            code: "Examinee:ListOfGroups:tab1:rest",
            parent_code: "Examinee:ReviewList",
          },
          "statetime"
        );
        this.UnAnditExamListData();
      }
      // 已审核
      if (this.status1) {
        // 初始化条件筛选框
        this.auditStatus = "";
        this.departmentName = "";
        this.pTitle = "";
        this.AuditValue = "";
        // 初始化多选框
        this.multipleSelectionAll1 = [];
        this.multipleSelection1 = [];
        this.changePageCoreRecordDataStats1 = true;
        // 初始化查询接口请求参数
        this.currentPage = 1;
        this.readyListPara.searchStr = "";
        this.readyListPara.department = "";
        this.readyListPara.pTitle = "";
        this.readyListPara.examineType = "";
        this.Buriedpoint(
          {
            code: "Examinee:ListOfGroups:tab2:rest",
            parent_code: "Examinee:ReviewList",
          },
          "statetime"
        );
        this.examineReadyStudentList();
      }
    },
    // 编辑
    editClick(row) {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:tab1:edit",
          parent_code: "Examinee:ReviewList",
        },
        "statetime"
      );
      this.dialogFormVisible = true;
      this.isEdit = true;
      console.log(row, "编辑");
      this.editData = [];
      this.editData.push(
        row.UserName,
        row.RealName,
        row.DepartmentName,
        row.PTitle,
        row.Position,
        row.Birthday,
        row.UserID,
        row.job
      );
      this.timer = new Date().getTime();
    },
    // 审核通过
    passAduit(row) {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:tab1:pass",
          parent_code: "Examinee:ReviewList",
        },
        "statetime"
      );
      this.flag = 0;
      this.dialogDelVisible = true;
      this.typeTitle = "审核通过";
      this.content = `是否通过"${row.RealName}"，账号为"${row.UserName}"考生的审核申请`;
      this.textareaContent = "审核通过";
      this.rowData = row;
    },
    // 审核驳回
    reviewRejected(row) {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:tab1:back",
          parent_code: "Examinee:ReviewList",
        },
        "statetime"
      );
      this.flag = 1;
      this.dialogDelVisible = true;
      this.typeTitle = "审核驳回";
      this.content = `是否驳回"${row.RealName}",账号为"${row.UserName}"考生的审核申请？`;
      this.textareaContent = "审核驳回";
      this.rowData = row;
    },
    // 批量审核通过
    addExaminee() {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:tab1:batchPass",
          parent_code: "Examinee:ReviewList",
        },
        "statetime"
      );
      this.flag = 2;
      this.dialogDelVisible = true;
      this.typeTitle = "批量审核通过";
      this.content = "是否通过考生的审核申请？";
      this.textareaContent = "审核通过";
    },
    // 批量审核驳回
    bulkImportBtn() {
      this.Buriedpoint(
        {
          code: "Examinee:ListOfGroups:tab1:batchBack",
          parent_code: "Examinee:ReviewList",
        },
        "statetime"
      );
      this.flag = 3;
      this.dialogDelVisible = true;
      this.typeTitle = "批量审核驳回";
      this.content = "是否驳回考生的审核申请?";
      this.textareaContent = "审核驳回";
    },

    switchElement(flag) {
      console.log("flag========" + flag);
      let row = this.rowData;
      const reqParam = new Object();
      this.UtilFun(reqParam);
      switch (flag) {
        case 0:
          reqParam.isExamine = "1";
          reqParam.studentIDArr = `[${`"${[row.UserID]}"`}]`;
          reqParam.departmentNameArr = `[${`"${[row.DepartmentName]}"`}]`;
          reqParam.examineRemark = this.textareaContent;
          console.log(reqParam, "审核通过请求参数");
          this.examineStudent(reqParam);
          // this.examineStudent(
          //   1,
          //   `[${`"${stuIdArr}"`}]`,
          //   `[${`"${depNameArr}"`}]`
          // );
          break;
        case 1:
          reqParam.isExamine = "0";
          reqParam.studentIDArr = `[${`"${[row.UserID]}"`}]`;
          reqParam.departmentNameArr = `[${`"${[row.DepartmentName]}"`}]`;
          reqParam.examineRemark = this.textareaContent;
          console.log(reqParam, "审核驳回请求参数");
          this.examineStudent(reqParam);
          // this.examineStudent(
          //   0,
          //   `[${`"${stuIdArr}"`}]`,
          //   `[${`"${depNameArr}"`}]`
          // );
          break;
        case 2:
          reqParam.isExamine = "1";
          reqParam.examineRemark = this.textareaContent;
          reqParam.studentIDArr = `[${`${this.getAllSelectionUserID()}`}]`;
          reqParam.departmentNameArr = `[${`"${[row.DepartmentName]}"`}]`;
          console.log(reqParam, "批量审核通过请求参数");
          this.examineStudent(reqParam);
          // this.examineStudent(1, `[${`"${this.ids}"`}]`);
          break;
        case 3:
          reqParam.isExamine = "0";
          reqParam.examineRemark = this.textareaContent;
          reqParam.studentIDArr = `[${`${this.getAllSelectionUserID()}`}]`;
          reqParam.departmentNameArr = `[${`"${[row.DepartmentName]}"`}]`;
          console.log(reqParam, "批量审核驳回请求参数");
          this.examineStudent(reqParam);
          // this.examineStudent(0, `[${`"${this.ids}"`}]`);
          break;

        default:
          break;
      }
      this.dialogDelVisible = false;
    },
  },
  created() {
    this.stateArr = [];
    this.getSectionData();
    this.getPTitleData();
    // 待审核考生列表刷新
    this.UnAnditExamListData();
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang='scss' scoped>
.content {
  height: 100%;
  width: 100%;
  min-width: 1650px;
}
.btnSwitch {
  height: 93px;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}
.testTypeBtn {
  width: 180px;
  height: 50px;
  background: #ffffff;
  font-family: PingFang SC;
  margin-left: 0px;
}
.isActiveClass {
  color: #ffffff;
  background-color: #1890ff;
}
.detailContent {
  width: 1642px;
  height: 889px;
  background: #ffffff;
  opacity: 1;
  border-radius: 10px;
}
.serchTerms {
  height: 81px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-right: 20px;
  margin-top: 24px;
  border-radius: 10px;
  padding: 0;
  margin-bottom: 24px;
  > div {
    &:nth-child(1) {
      margin-left: 30px !important;
    }
    margin: 0px 12px;
  }
  span {
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    margin-right: 5px;
  }
}
.operaBtn {
  display: flex;
  margin: 14px 0px 20px 24px;
  width: 849px;
  height: 40px;
  opacity: 1;
  background-color: white;

  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    width: 140px;
    height: 40px;
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
  }
  .el-button:nth-child(2) {
    width: 140px;
    height: 40px;
    background: #e54d4d;
    opacity: 1;
    border-radius: 4px;
  }
}

// 表格内容
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #8fcbff;
  color: #333333;
  opacity: 1;
}

.el-table__header {
  width: 100% !important;
}
.el-table__body {
  width: 100% !important;
}

::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

.AuditTable {
  padding: 0px 24px;
  .el-button {
    font-size: 16px;
  }
}

// 分页
.footBox {
  position: relative;
  height: 110px;
  .footPage {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

::v-deep .newAddKS .el-dialog {
  width: 537px;
  height: 743px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}

::v-deep .newAddKS .el-input {
  width: 380px;
}

::v-deep .newAddKS .el-form-item label {
  width: 100px !important;
  text-align: left;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  font-family: "Microsoft YaHei";
}

::v-deep .newAddKS .el-select {
  width: 380px;
}

.dialogBox {
  position: relative;
  margin-left: 24px;
}

.dialogBox .el-button {
  left: 380px;
  position: absolute;
  width: 114px;
  height: 40px;
  background: #1890ff;
  opacity: 1;
  border-radius: 4px;
  color: white;
}

::v-deep .dialog-footer {
  display: flex;
  justify-content: center;
  .el-button {
    margin-right: 30px;
  }
  margin-bottom: 20px;
}

::v-deep .deleteBatches .el-dialog {
  width: 428px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}

.deleteBatches .dialogContent {
  width: 182px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 24px;
  color: #333333;
  opacity: 1;
}

#area {
  width: 380px;
  height: 100px;
  margin-top: 14px;
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.flex_box {
  height: 81px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
}
.query_btn {
  margin: 0;
  display: flex;
  margin-right: 30px;
  ::v-deep .el-button {
    width: 88px;
    height: 40px;
    margin-left: 36px;
  }
}
</style>

// <style lang="scss">
// .el-table__body {
//   // 使表格兼容safari，不错位
//   width: 100%;
//   table-layout: fixed !important;
// }
//
</style>